export type AgeUnit = 'year' | 'month' | 'week';

const allowOneDecimalPlace = (value: number) => {
  return value.toFixed(1).replace(/\.0$/, '');
};

export const stringifyDaysOld = (daysOld: number, useOld = true) => {
  const { amount, unit } = getAgeDivision(daysOld);

  switch (unit) {
    case 'year':
      return `${amount} yr${useOld ? ' old' : ''}`;
    case 'month':
      return `${amount} mo${useOld ? ' old' : ''}`;
    case 'week':
      return `${amount} wk${useOld ? ' old' : ''}`;
  }
};

export const getAgeDivision = (
  daysOld: number,
): { amount: string; unit: AgeUnit } => {
  const dayInYears = 365;
  const daysInMonth = 30.44; // Average days in a month
  const months = daysOld / daysInMonth;

  if (daysOld >= 2 * dayInYears) {
    // Years: round down
    return { amount: String(Math.floor(daysOld / dayInYears)), unit: 'year' };
  } else if (months >= 1) {
    // Months: use one decimal place
    return { amount: allowOneDecimalPlace(months), unit: 'month' };
  } else {
    // Weeks: round up
    return { amount: String(Math.ceil(daysOld / 7)), unit: 'week' };
  }
};
